import { Alert, Box } from "@mui/material";
import * as React from "react";

import { TokensTable } from "@/shared/components/tokens";
import { useDeviceTokens } from "@/shared/domain/devices/hooks/useDevice.ts";

interface DeviceTokenProps {
  deviceId: string;
}

export function DeviceTokens({ deviceId }: DeviceTokenProps) {
  const deviceTokensQuery = useDeviceTokens(deviceId);
  const deviceTokens = deviceTokensQuery.data;
  const [errorText, setErrorText] = React.useState<string>();

  return (
    <>
      {errorText && <Alert severity="error">{errorText}</Alert>}

      {deviceTokens && (
        <Box margin={2}>
          <TokensTable
            data={deviceTokens}
            loading={deviceTokensQuery.isLoading}
            refetch={() => {
              void deviceTokensQuery.refetch();
            }}
            setErrorText={setErrorText}
            noResultsComponent={
              <Alert severity="info">
                This device has no access tokens yet. These are only required
                for devices which directly interact with Roboto, typically to
                upload data. For more information, refer to{" "}
                <a href="https://docs.roboto.ai/learn/devices.html#registration">
                  device registration
                </a>
                .
              </Alert>
            }
          />
        </Box>
      )}
    </>
  );
}
